import Images from './Images'

interface HomeLink {
  icon: Images
  description: string
  title: string
  link: string
}

const HomeLinks: HomeLink[] = [
  {
    icon: Images.IconImplement,
    description: 'How does it fit in the production process?',
    title: 'Implementing',
    link: '/ulaval/implementation'
  },
  {
    icon: Images.IconModelling,
    description: 'What is our team doing?',
    title: 'Modelling',
    link: '/ulaval/model'
  },
  {
    icon: Images.IconSafety,
    description: 'How is it safe in and outside of the lab?',
    title: 'Safety',
    link: '/ulaval/safety'
  },
  {
    icon: Images.IconTeam,
    description: 'Who is behind this project?',
    title: 'Team',
    link: '/ulaval/team'
  }
]

export default HomeLinks
